import { FieldDataService } from "src/app/services/fieldData/field-data.service";
import { NodeAlarmComponent } from "./../node-alarm/node-alarm.component";
import { LoginService } from "./../../services/login/login.service";
import moment from "moment-timezone";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  NgZone,
  AfterViewInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Apollo } from "apollo-angular";
import { NavigationEnd } from "@angular/router";
import {
  queryNavegacionDato,
  cambiarFormula,
  asignarFuncion,
  cambiarVariable,
  queryDispositivosRaiz,
  queryFunciones,
  ActualizarDato,
  queryAddDependency,
  queryDeleteDepedency,
  recalcularDato,
  cambiarZonaHoraria,
  ActualizarDescripcion,
  updateDato,
  actualizarFormulaDep,
} from "./querys/queryNavDatos";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { DialogData } from "src/app/components/utilidades/interfaces/ventana-dsp.data";
import { MatDialog } from "@angular/material/dialog";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { Subscription, of, Observable } from "rxjs";
import { NavegacionDependenciasComponent } from "../navegacion-dependencias/navegacion-dependencias.component";
import { TimezoneService, Timezone } from "src/app/services/timezone.service";
import { RealTimeService } from "./../../services/real-time.service";

// Query que recupera los datos del servidor del tipo de dato
interface Dato {
  descripcion?: string;
  uuid?: string;
  next?: number;
  invalidated?: number;
  stats_q1?: number;
  stats_q3?: number;
  stats_min?: number;
  stats_max?: number;
  stats_median?: number;
  stats_mean?: number;
  stats_stddev?: number;
  stats_pbottom?: number;
  stats_ptop?: number;
  stats_count?: number;
  periodo?: string;
  zonaHoraria?: string;
  dependeFromConnection: {
    edges: [
      {
        uuid: string;
        variable: string;
        node: DependeFromDato;
      }
    ];
  };
  dependeToConnection: {
    edges: [
      {
        uuid: string;
        variable: string;
        node: DependeToDato;
      }
    ];
  };
  entradasConnection?: {
    edges: [
      {
        uuid: string;
        topic: string;
        desde: number;
        hasta: number;
        node: {
          uuid: string;
          topic: string;
          entradas: [
            {
              uuid: string;
              topic: string;
              desde: number;
              hasta: number;
            }
          ];
        };
      }
    ];
  };
  es?: {
    uuid?: string;
    nombre?: string;
  };
  tiene?: {
    uuid: string;
    nombre: string;
  };
  depende?: {
    to?: [Depende];
    from?: [Depende];
  };
  calculaConnection?: {
    edges: [
      {
        uuid: string;
        disabled: number;
        error: string;
        formula: string;
        desde: number;
        hasta: number;
        node: {
          descripcion: string;
          codigo: string;
        };
      }
    ];
    uuid?: string;
    disabled?: string;
    error?: string;
    formula?: string;
    from?: {
      uuid?: string;
      codigo?: string;
    };
  };
}

interface DependeToDato {
  dependeToConnection: [Dato];
}

interface DependeFromDato {
  dependeFromConnection: [Dato];
}

interface Depende {
  uuid: string;
  variable: string;
  to: Dato;
}

interface DataDato {
  to: Dato;
  uuid: string;
  variable?: string;
}

interface addDependency {
  addDependency: Number;
}

interface deleteDependency {
  deleteDependency: Number;
}

interface Funcion1 {
  uuid: string;
  codigo: string;
}

interface Funcion {
  findFunciones: [Funcion1];
}

@Component({
  selector: "app-arbolDatos",
  templateUrl: "./arbolDatos.component.html",
  styleUrls: ["./arbolDatos.component.scss"],
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger("rotatedState", [
      state("default", style({ transform: "rotate(0)" })),
      state("rotated", style({ transform: "rotate(-360deg)" })),
      transition("rotated => default", animate("450ms ease-out")),
      transition("default => rotated", animate("450ms ease-in")),
    ]),
  ],
})
export class arbolDatos implements OnInit, OnDestroy {
  // Para rotar los iconos
  state: string = "default";

  // Para la zona horaria:
  timezoneCollection: Timezone[] = [];
  utcCollection: string[] = [];
  zonaHorariaDato = "Sin zona horaria definida";
  arrayTz: string[] = [];
  arrayTz2: string[];
  _jsonURL = "assets/data/timezones.json";

  // Definimos las variables que vamos a utilizar dentro de la clase:
  dato: any;
  panelOpenState = false; // Para el desplegable del error:
  panelHeight = "25px";
  uuid: string;
  mySubscription: any; // Para hacer creer a angular que no hemos navegado al mimo componente!
  public querySubscription: any;
  to: Dato;
  datoActual = {
    uuid: "",
    nombre: "",
    uuidMedicion: "",
    nombreMedicion: "",
    next: 0,
    invalidated: 0,
    stats_median: 0,
    stats_stddev: 0,
    stats_pbottom: 0,
    stats_ptop: 0,
    stats_count: 0,
    disabled: "",
    error: "",
    codigo: "",
  };
  dependeTo: [Depende];
  dependeFrom: [Depende];
  data: DataDato;
  nombreHeader: string;
  dependeHeader: string;
  datoHeader: string;
  datoDescripcion: string;
  datoUpperLimit: number;
  datoLowerLimit: number;

  timezone: string;
  toPlotly: number;
  fromPlotly: number;
  graphConfig: any;
  roles: any;

  // Data Sources para los datos:
  displayedColumnsSources: string[] = [
    "sourceuuid",
    "sourcetopic",
    "entradauuid",
    "entradatopic",
    "desde",
    "hasta",
  ];
  dataSourceSources: MatTableDataSource<any>;
  @ViewChild("TableSourcesPaginator") tableSourcesPaginator: MatPaginator;

  displayedColumnsTo: string[] = [
    "uuidDato",
    "nombreDispositivo",
    "tipoDato",
    "formula",
    "datosTotales",
    "next",
    "invalidated",
    "limiteInferior",
    "limiteSuperior",
    "mediana",
    "desviacion",
    "fCalculo",
    "dependen",
    "botones",
  ];
  dataSourceTo: MatTableDataSource<any>;
  @ViewChild("TableToPaginator", { static: true })
  tableToPaginator: MatPaginator;

  displayedColumnsFrom: string[] = [
    "uuidDato",
    "nombreDispositivo",
    "tipoDato",
    "formula",
    "datosTotales",
    "next",
    "invalidated",
    "limiteInferior",
    "limiteSuperior",
    "mediana",
    "desviacion",
    "fCalculo",
    "dependen",
    "botones",
  ];
  dataSourceFrom: MatTableDataSource<any>;
  @ViewChild("TableFromPaginator", { static: true })
  tableFromPaginator: MatPaginator;
  Paginator;

  loading = true;
  datoActualuuidMedicion: string;
  datoActualuuidNombre: string;
  uuidRelacionDepende: string;

  uuidDispositivo: string;
  introManual: boolean = false;

  // Para modificar la función de cálculo:
  funciones: any;
  opcionesFuncion = [];
  sinFuncion: string = "Sin funcion definida";
  public vpop: DialogData = {
    fabricas: [],
    dispositivo: {
      uuid: "",
      nombre: "",
    },
    dato: {
      uuid: "",
      periodo: "",
      descripcion: "",
    },
    tipoDato: {
      uuid: "",
      nombre: "",
      unidad: "",
    },
  };

  // Para el modal
  closeResult: string;
  TituloModal: string;
  NombreDispositivoModal: string;
  TipoDatoModal: string;
  uuidModal: string;
  FuncionCalculoModal: string;
  Pbottom: number;
  Ptop: number;
  variableManualModal: string;
  opcionesVariableModal = [];
  opcionesVariableModal2 = [];
  variableModal: string;
  config = {
    displayKey: "description", //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: "auto",
    width: "1000px",
    placeholder: "Seleccionar variable", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // options.length // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: "extra", // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: "Sin resultados", // text to be displayed when no items are found while searching
    searchPlaceholder: "Buscar variable", // label thats displayed in search input,
    clearOnSelection: true, // clears search criteria when an option is selected if set to true, default is false
  };
  public querySubscription1: any;
  uuidDependencia: string;
  dataSourceData: any;

  alarmsCount: number;

  dataArrayIdentifiers: string[];

  layoutRT: any;
  trace$: Observable<any> = of(null);

  configRT: any;
  formulaDependencia: any;
  calculaDesde: number;
  calculaHasta: number;
  isCalculated: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apollo: Apollo,
    private router: Router,
    private modalService: NgbModal,
    private toastrservice: ToastrService,
    public dialog: MatDialog,
    private loginService: LoginService,
    private timezoneService: TimezoneService,
    private fieldDataService: FieldDataService,
    private rtService: RealTimeService
  ) {}

  ngOnInit() {
    // Con las dos suscripciones de debajo, hacemos creer a angular que no hemos visitado el componente
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });

    // Nos suscribimos al parametro de uuid del link para saber a que dispositivo tenemos que navegar
    // a continuacion.
    // Nota: El "this.activatedRoute.params.subscribe" inferior puede modificarse por
    //       "this.activatedRoute.queryParams.subscribe" en funcion del resultado que se espere
    this.activatedRoute.params.subscribe((params) => {
      // const uuid = params['uuid'];
      this.uuid = params.uuid;
    });
    this.getFunciones();
    this.getData();

    // Para extraer las opciones de zonas horarias:
    // this.getTimeZoneCollection()
  } // cierra el OnInit
  // Para recuperar datos [Aquí metemos todas las consultas que vayan a traernos datos]

  getData() {
    // PARA RT
    this.configRT = {
      layout: {
        width: "400px",
        height: "400px",
        margin: {
          l: 50,
          r: 70,
          b: 75,
          t: 0,
          pad: 4,
        },
      },
      config: {
        displayModeBar: false,
        responsive: true,
      },
    };

    this.fieldDataService.getNodeAlarmsDetail([this.uuid]).subscribe((data) => {
      this.alarmsCount = data.data.getNodeAlarmsDetail.filter(
        (elem) => elem.properties.alarmado
      ).length;
    });

    this.querySubscription = this.apollo
      .query<any>({
        query: queryNavegacionDato,
        fetchPolicy: "network-only",
        variables: {
          uuid: this.uuid,
        },
      })
      // .valueChanges
      .subscribe(({ data, loading }) => {
        this.timezone = this.loginService.currentUserValue.timeZone;
        this.roles = this.loginService.currentUserValue.rol;
        this.toPlotly = moment.unix(new Date()).tz(this.timezone).unix();
        this.fromPlotly = this.toPlotly - 6 * Math.pow(10, 8); // Le quitamos 1 semana al momento actual
        this.graphConfig = {
          dispositivos: [],
          from: this.fromPlotly,
          to: this.toPlotly,
          limit: null,
          tipoDato: [],
          type: "scattergl",
          mode: "lines+points",
          layout: {
            width: 550,
            height: 200,
            margin: {
              l: 50,
              r: 25,
              b: 75,
              t: 0,
              pad: 4,
            },
          },
        };

        this.to = data.getDato;
        this.dato = data.getDato;
        this.getDatoByDependencyTo(this.dato);
        // Comentado para poder acceder hasta la navegación de dato, hay que solucionarlo
        let datosDependencias = this.getDatoByDependencyTo(this.dato);
        this.dataSourceSources = new MatTableDataSource(
          datosDependencias.sources
        );
        this.dataArrayIdentifiers = datosDependencias.sources.map(
          (s) => s.topic
        );
        this.dataSourceSources.paginator = this.tableSourcesPaginator;
        this.dataSourceSources.filterPredicate = (data, filter: string) => {
          const accumulator = (currentTerm, key) => {
            return this.nestedFilterCheck(currentTerm, data, key);
          };
          const dataStr = Object.keys(data)
            .reduce(accumulator, "")
            .toLowerCase();
          // Transform the filter by converting it to lowercase and removing whitespace.
          const transformedFilter = filter.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };

        // Rellenamos datos para cargar en la vista[¿no permite pasar objetos?]
        this.datoDescripcion = this.to.descripcion;
        this.datoUpperLimit = data.getDato.limiteSuperior;
        this.datoLowerLimit = data.getDato.limiteInferior;
        this.uuidDispositivo = this.to.tiene.uuid;
        this.graphConfig.dispositivos.push(this.to.tiene.uuid);
        this.nombreHeader = this.to.es.nombre;
        this.dependeHeader = this.to.tiene.nombre;
        this.datoActual.uuid = this.to.uuid;
        this.datoActual.nombre = this.to.tiene.nombre;
        this.datoActualuuidNombre = this.to.tiene.nombre;
        this.datoActual.uuidMedicion = this.to.es.uuid;
        this.graphConfig.tipoDato.push(this.to.es.uuid);
        this.datoActualuuidMedicion = this.to.es.uuid;
        this.datoActual.nombreMedicion = this.to.es.nombre;
        this.datoActual.next = this.to.next;
        this.datoActual.invalidated = this.to.invalidated;
        this.datoActual.stats_median = this.to.stats_median;
        this.datoActual.stats_stddev = this.to.stats_stddev;
        this.datoActual.stats_pbottom = this.to.stats_pbottom;
        this.datoActual.stats_ptop = this.to.stats_ptop;
        this.datoActual.stats_count = this.to.stats_count;
        if (
          this.to.calculaConnection.edges &&
          this.to.calculaConnection.edges.length > 0
        ) {
          this.datoActual.codigo ==
            this.to.calculaConnection.edges[0].node.codigo;
        } else {
          this.datoActual.codigo = "Sin funcion de calculo";
        }
        if (this.to.calculaConnection.disabled) {
          this.datoActual.disabled = this.to.calculaConnection.disabled;
        }
        if (this.to.calculaConnection) {
          this.datoActual.error = this.to.calculaConnection.error;
        }
        if (
          this.to.calculaConnection &&
          this.to.calculaConnection.edges.length > 0
        ) {
          this.isCalculated = true;
          this.datoHeader = this.to.calculaConnection.edges[0].node.codigo;
          this.calculaDesde = this.to.calculaConnection.edges[0].desde
            ? this.to.calculaConnection.edges[0].desde / Math.pow(10, 6)
            : null;
          this.calculaHasta = this.to.calculaConnection.edges[0].hasta
            ? this.to.calculaConnection.edges[0].hasta / Math.pow(10, 6)
            : null;
        } else {
          this.datoHeader = "Sin funcion de calculo";
        }
        if (this.to.zonaHoraria != null) {
          this.zonaHorariaDato = this.to.zonaHoraria;
        } else {
          this.zonaHorariaDato = "Sin zona horaria";
        }
        // if (!this.to.calcula) { this.to.calcula.Funcion.codigo = 'Sin funcion de calculo }'}
        // Restablecemos a 0 la longitud de los arrays de las variables de las formulas
        this.opcionesVariableModal.length = 0;
        this.opcionesVariableModal2.length = 0;
        // Para las opciones de la formula:

        // Con esto retornamos todo lo que está entre los {} de la formula del dato actual!
        if (
          this.to.calculaConnection.edges &&
          this.to.calculaConnection.edges.length > 0 &&
          this.to.calculaConnection.edges[0].formula
        ) {
          var rxp = /{([^}]+)}/g,
            str = this.to.calculaConnection.edges[0].formula,
            curMatch;

          while ((curMatch = rxp.exec(str))) {
            this.opcionesVariableModal.push(curMatch[1]);
          }
          this.opcionesVariableModal.push("sin_variable");
        } else {
          this.opcionesVariableModal.push("variable");
          this.opcionesVariableModal2.push("variable");
        }
        this.loading = loading;
        this.querySubscription.unsubscribe();
      });

    this.getTimeZoneCollection();
  }

  getFunciones() {
    this.apollo
      .query<Funcion>({
        query: queryFunciones,
        fetchPolicy: "network-only",
      })
      .subscribe(({ data }) => {
        this.opcionesFuncion = [];
        this.funciones = data.findFunciones;
        for (let _i = 0; _i < this.funciones.length; _i++) {
          if (this.funciones[_i].codigo == null) continue;
          this.opcionesFuncion.push({
            codigo: this.funciones[_i].codigo,
            uuid: this.funciones[_i].uuid,
          });
        }
      });
  }

  // Para navegar a cualquier nivel del objeto que forman las tablas y poder filtrar!

  rotate() {
    this.state = this.state === "default" ? "rotated" : "default";
  }

  nestedFilterCheck(search, data, key) {
    if (typeof data[key] === "object") {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

  previousState() {
    window.history.back();
  }

  getDatoByDependencyTo(dato: Dato) {
    let arrayOfDatosTo = [];
    let arrayOfDatosFrom = [];
    let sourcesTo = dato.entradasConnection.edges;
    let datoTo = dato.dependeToConnection.edges; //.map(r=>r.uuid)
    this.dataSourceData = datoTo;
    let datoFrom = dato.dependeFromConnection.edges; //.map(r=>r.uuid)
    this.dataSourceTo = new MatTableDataSource(datoTo);
    this.dataSourceTo.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        return this.nestedFilterCheck(currentTerm, data, key);
      };
      const dataStr = Object.keys(data).reduce(accumulator, "").toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSourceFrom = new MatTableDataSource(datoFrom);
    this.dataSourceFrom.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        return this.nestedFilterCheck(currentTerm, data, key);
      };
      const dataStr = Object.keys(data).reduce(accumulator, "").toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSourceTo.paginator = this.tableFromPaginator;
    this.dataSourceFrom.paginator = this.tableFromPaginator;

    return {
      dependenciasFrom: arrayOfDatosFrom,
      dependenciasTo: arrayOfDatosTo,
      sources: sourcesTo,
    };
  }

  // Para el modal (ORIGINAL), fuera del oninit:
  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.introManual = false;
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  // Método que extrae datos de la fila de la tabla para luego cargarla en el modal:
  saveData(d) {
    this.TituloModal = d.node.tiene.nombre;
    this.NombreDispositivoModal = d.node.tiene.nombre;
    this.TipoDatoModal = d.node.es.nombre;
    this.uuidModal = d.node.uuid;
    this.variableModal = d.variable;
    this.uuidRelacionDepende = d.uuid;
    this.formulaDependencia = d.formula;
  }

  actualizarDato() {
    this.apollo
      .mutate({
        mutation: ActualizarDato,
        variables: {
          uuid: this.uuidModal,
          stats_pbottom: this.Pbottom,
          stats_ptop: this.Ptop,
        },
      })
      .subscribe(() => {
        this.getData();
      });
  }

  addDependency() {
    this.apollo
      .mutate<addDependency>({
        mutation: queryAddDependency,
        variables: {
          datouuid: this.uuid,
          depuuid: this.uuidDependencia.trim(),
        },
      })
      .subscribe(({ data }) => {
        if (data.addDependency && this.uuidDependencia.trim() != this.uuid) {
          this.toastrservice.success("", "Dependencia añadida correctamente", {
            closeButton: true,
          });
          this.getData();
        } else {
          this.toastrservice.error(
            "Verifica el uuid introducido",
            "No se ha podido añadir la dependencia",
            { closeButton: true }
          );
        }
      });
  }

  deleteDependency(d) {
    if (
      confirm(
        "¿Eliminar la dependencia " +
          d.node.tiene.nombre +
          " del dispositivo " +
          this.dependeHeader +
          "?"
      )
    ) {
      this.apollo
        .mutate<deleteDependency>({
          mutation: queryDeleteDepedency,
          variables: {
            duuid: d.uuid,
          },
        })
        .subscribe(
          ({ data }) => {
            if (data.deleteDependency != 0) {
              this.toastrservice.success(
                "",
                "Dependencia eliminada correctamente",
                { closeButton: true }
              );
              this.getData();
            }
          },
          (errors) => {
            this.toastrservice.error(
              "",
              "No se ha podido eliminar la dependencia",
              { closeButton: true }
            );
          }
        );
    }
  }

  applyFilterSources(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceSources.filter = filterValue.trim().toLowerCase();
  }

  applyFilterTo(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceTo.filter = filterValue.trim().toLowerCase();
  }

  applyFilterFrom(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFrom.filter = filterValue.trim().toLowerCase();
  }

  //TODO: copiado(event: Event) {
  copiado(event) {
    if (event) {
      this.toastrservice.info("", "uuid copiado al portapapeles", {
        closeButton: true,
        timeOut: 2000,
      });
    }
  }

  recalcularDato() {
    // Aplicar aquí la mutation cuando sepa la estructura;
    this.apollo
      .mutate({
        mutation: recalcularDato,
        variables: {
          uuidDato: this.uuid,
        },
      })
      .subscribe(
        ({ data }) => {
          if (data) {
            this.toastrservice.success("", "Recalculando el dato...", {
              closeButton: true,
            });
            this.getData();
          }
        },
        (errors) => {
          this.toastrservice.error("", "No se ha podido recalcular el dato", {
            closeButton: true,
          });
        }
      );
  }

  cambiarVariable() {
    if (this.introManual == true) {
      this.variableModal = this.variableManualModal;
    } else {
      this.variableModal = this.variableModal;
    }
    if (this.variableModal == "sin_variable") this.variableModal = null;
    this.apollo
      .mutate<any>({
        mutation: cambiarVariable,
        variables: {
          dependencia: this.uuidRelacionDepende,
          variable: this.variableModal,
        },
      })
      .subscribe({
        next: (data) => {
          if (data.data.cambiarVariable != null) {
            this.toastrservice.success("", "Variable cambiada correctamente", {
              closeButton: true,
            });
            this.getData();
          }
          this.getData();
          this.introManual = false;
          this.variableManualModal = "";
        },
        error: (errors) => {
          this.toastrservice.error("", "No se ha podido cambiar la variable", {
            closeButton: true,
          });
        },
      });
  }

  actualizarFormulaDep() {
    this.apollo
      .mutate<any>({
        mutation: actualizarFormulaDep,
        variables: {
          dependencia: this.uuidRelacionDepende,
          formula:
            this.formulaDependencia != "" ? this.formulaDependencia : null,
        },
      })
      .subscribe(
        ({ data }) => {
          if (data.actualizarFormulaDep != null) {
            this.toastrservice.success("", "Formula cambiada correctamente", {
              closeButton: true,
            });
          }
        },
        (errors) => {
          this.toastrservice.error("", "No se ha podido cambiar la formula", {
            closeButton: true,
          });
        }
      );
  }

  cambiarFormula() {
    this.apollo
      .mutate<any>({
        mutation: cambiarFormula,
        fetchPolicy: "no-cache",
        variables: {
          calcula: this.to.calculaConnection.edges[0].uuid,
          formula: this.to.calculaConnection.edges[0].formula,
        },
      })
      .subscribe(
        ({ data }) => {
          if (data) {
            this.toastrservice.success("", "Formula cambiada correctamente", {
              closeButton: true,
            });
            this.getData();
          }
        },
        (errors) => {
          this.toastrservice.error("", "No se ha podido cambiar la fórmula", {
            closeButton: true,
          });
        }
      );
  }

  cambiarFuncion(event) {
    this.apollo
      .mutate<any>({
        mutation: asignarFuncion,
        variables: {
          dato: this.uuid,
          funcion: event.uuid,
        },
      })
      .subscribe(
        ({ data }) => {
          if (data && data.asignarFuncion != null) {
            this.toastrservice.success("", "Función modificada correctamente", {
              closeButton: true,
            });
            this.getData();
          }
        },
        (errors) => {
          this.toastrservice.error(
            "Posible dato de entrada",
            "Error al modificar la función",
            { closeButton: true }
          );
        }
      );
  }

  habilitarManual(event) {
    this.introManual = event.target.checked;
  }

  cambiarDescripcion(desc: string) {
    this.apollo
      .mutate<any>({
        mutation: ActualizarDescripcion,
        variables: {
          uuid: this.uuid,
          descripcion: desc,
        },
      })
      .subscribe(
        ({ data }) => {
          if (data && data.UpdateDato != null) {
            this.toastrservice.success(
              "",
              "Descripción modificada correctamente",
              { closeButton: true }
            );
            this.getData();
          } else {
            this.toastrservice.error(
              "Error",
              "Error al modificar la descripción",
              { closeButton: true }
            );
          }
        },
        (errors) => {
          this.toastrservice.error(
            "Posible dato de entrada",
            "Error al modificar la función",
            { closeButton: true }
          );
        }
      );
  }

  updateDatoAction(
    descripcion: string,
    upperLimit: number,
    lowerLimit: number,
    desde: number,
    hasta: number
  ) {
    this.apollo
      .mutate<any>({
        mutation: updateDato,
        variables: {
          dato: this.uuid,
          depUUID:
            this.to.calculaConnection.edges &&
            this.to.calculaConnection.edges[0]
              ? this.to.calculaConnection.edges[0].uuid
              : null,
          descripcion: descripcion,
          desde: desde ? desde : null,
          hasta: hasta ? hasta : null,
          limiteInferior: lowerLimit,
          limiteSuperior: upperLimit,
        },
      })
      .subscribe(
        ({ data }) => {
          if (upperLimit >= lowerLimit && data.updateDato) {
            this.toastrservice.success(
              "Información actualizada correctamente.",
              "Éxito",
              { closeButton: true }
            );
            this.getData();
          } else {
            this.toastrservice.error(
              "Error al actualizar la información. El límite inferior es mayor que límite superior, o el valor de alguno de los límites es superior al máximo permitido (Int 32 bit).",
              "Error",
              { closeButton: true }
            );
            this.getData();
          }
        },
        (erors) => {
          this.toastrservice.error(
            "Posible dato de entrada",
            "Error al modificar la función",
            { closeButton: true }
          );
        }
      );
  }

  depNav(uuid_dependencia) {
    this.apollo
      .mutate<addDependency>({
        mutation: queryAddDependency,
        variables: {
          datouuid: this.uuid,
          depuuid: uuid_dependencia.trim(),
        },
      })
      .subscribe(({ data }) => {
        if (data.addDependency && uuid_dependencia.trim() != this.uuid) {
          this.toastrservice.success("", "Dependencia añadida correctamente", {
            closeButton: true,
          });
          this.getData();
        } else {
          this.toastrservice.error(
            "Verifica el uuid introducido",
            "No se ha podido añadir la dependencia",
            { closeButton: true }
          );
        }
      });
  }

  navegacionDependenciasTo() {
    const qpf: Subscription = this.apollo
      .query<any>({
        query: queryDispositivosRaiz,
        fetchPolicy: "network-only",
      })
      .subscribe(({ data }) => {
        this.vpop.fabricas = [];
        this.vpop.fabricas = [...data.datos];
        this.vpop.fabricas.sort((a, b) =>
          a.nombre > b.nombre ? 1 : b.nombre > a.nombre ? -1 : 0
        );
        const dialogRef = this.dialog.open(NavegacionDependenciasComponent, {
          panelClass: "dialogNavegacion",
          width: "45%",
          height: "60%",
          data: this.vpop,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) this.depNav(result.uuid);
        });
      });
  }

  cambiarZonaHoraria(event) {
    this.apollo
      .mutate<any>({
        mutation: cambiarZonaHoraria,
        variables: {
          uuid: this.uuid,
          zonaHoraria: event.value,
        },
      })
      .subscribe(
        ({ data }) => {
          if (data && data.UpdateDato != null) {
            this.toastrservice.success(
              "",
              "Zona horaria modificada correctamente",
              { closeButton: true }
            );
            this.getData();
          } else {
            this.toastrservice.error(
              "",
              "No ha sido posible modificar la zona horaria",
              { closeButton: true }
            );
          }
        },
        (errors) => {
          this.toastrservice.error(
            "",
            "No ha sido posible modificar la zona horaria",
            { closeButton: true }
          );
        }
      );
  }

  getTimeZoneCollection() {
    this.timezoneService
      .getTimezoneCollection()
      .subscribe((data: Timezone[]) => {
        this.timezoneCollection = data;
        for (const timezone of data) {
          for (const utc of timezone.utc) {
            this.utcCollection.push(utc);
          }
        }
        this.utcCollection = this.utcCollection.sort();
      });
  }

  openAlertsComponent() {
    const dialogRef = this.dialog.open(NodeAlarmComponent, {
      data: {
        uuid: this.uuid,
        componentMode: "dato",
        nodeType: "source",
        title: "Nodos con alarmas en estado:",
      },
      height: "75%",
      width: "85%",
      minWidth: 270,
    });
    dialogRef.afterClosed().subscribe((dispositivo) => {});
  }

  actOverDatoAlarm(action: string, uuid: string) {
    switch (action) {
      case "silenciar":
        this.fieldDataService.silenceDato(uuid).subscribe(({ data }) => {
          if (data.data.silenceDato && !data.errors) {
            this.toastrservice.success("Dato silenciado con éxito");
          } else {
            this.toastrservice.error("No se ha podido silenciar el dato");
          }
        });
        break;
      case "rearmar":
        this.fieldDataService.rearmarDato(uuid).subscribe(({ data }) => {
          if (data.data.rearmarDato && !data.errors) {
            this.toastrservice.success("Dato rearmado con éxito");
          } else {
            this.toastrservice.error("No se ha podido rearmar el dato");
          }
        });
        break;
    }
  }

  rearmaAlarmaNodo() {
    alert(
      "Alarma rearmada, se volverá a notificar cualquier incidencia sobre este nodo y su estructura"
    );
  }

  ngOnDestroy() {
    // Desuscribirnos de las querys!
    this.querySubscription.unsubscribe();
    this.mySubscription.unsubscribe();
  }
}
